// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
require('./_set-collection-of')('Set');



// WEBPACK FOOTER //
// webpack:///node_modules/core-js/library/modules/es7.set.of.js